import React, { useState } from "react";
import "./Login.css";
import ResetPassword from "./SetPassword";
import Footer from "../Pages/Footer";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [isResetting, setIsResetting] = useState(false);
    const [resetEmail, setResetEmail] = useState("");
    const [showPassword, setShowPassword] = useState(false); // State to show/hide password

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email || !password) {
            setError("Please fill in both email and password.");
            return;
        }

        setLoading(true);
        setError("");

        try {
            const response = await fetch("http://localhost:5000/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ email, password }),
            });

            setLoading(false);

            if (response.ok) {
                const data = await response.json();
                alert(`Login successful: ${data.message}`);
                setEmail("");
                setPassword("");
                console.log(data);
            } else {
                const errorData = await response.json();
                setError(`Login failed: ${errorData.error}`);
            }
        } catch (error) {
            setLoading(false);
            console.error("Error during login request:", error);
            setError("An error occurred while logging in. Please try again.");
        }
    };

    const handleResetRequest = (e) => {
        e.preventDefault();
        setIsResetting(true);  // Switch to reset password form
    };

    const handleBackToLogin = () => {
        setIsResetting(false);  // Return to the login form
    };

    return (
      <div>
        <div className="login-container">
            {isResetting ? (
                // Reset Password Form
                <ResetPassword 
                    setIsResetting={setIsResetting} 
                    resetEmail={resetEmail} 
                    setResetEmail={setResetEmail} 
                    handleBackToLogin={handleBackToLogin} 
                />
            ) : (
                // Login Form
                <form onSubmit={handleSubmit} className="login-form">
                    <div className="input-group">
                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            required
                            className="login-input"
                        />
                    </div>

                    <div className="input-group">
                        <label htmlFor="password">Password</label>
                        <div className="password-container">
                            <input
                                type={showPassword ? "text" : "password"}  // Toggle password visibility
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Enter your password"
                                required
                                className="login-input"
                            />
                            <span
                                onClick={() => setShowPassword(!showPassword)}  // Toggle visibility on click
                                className="show-password-toggle"
                            >
                                {showPassword ? "Hide" : "Show"}
                            </span>
                        </div>
                    </div>

                    {error && <p className="error-message">{error}</p>}
                    <button type="submit" className="login-button" disabled={loading}>
                        {loading ? "Processing..." : "Login"}
                    </button>
                </form>
            )}

            {!isResetting && (
                <div className="forgot-password">
                    <p onClick={handleResetRequest} className="link">Forgot your password?</p>
                </div>
            )}
            </div>
            <Footer/>
        </div>
    );
};

export default Login;



// import React, { useState } from 'react';
// import axios from 'axios';

// function Login() {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');

//   const handleLogin = async () => {
//     try {
//       const res = await axios.post('/api/auth/login', { email, password });
//       localStorage.setItem('token', res.data.token);
//       alert('Login Successful');
//     } catch (err) {
//       if (err.response.data.msg === 'Password not set. Please set your password first.') {
//         window.location.href = `/set-password?email=${email}`;
//       } else {
//         setError(err.response.data.msg);
//       }
//     }
//   };

//   return (
//     <div>
//       <h2>Login</h2>
//       <input type="email" placeholder="Email" onChange={e => setEmail(e.target.value)} />
//       <input type="password" placeholder="Password" onChange={e => setPassword(e.target.value)} />
//       <button onClick={handleLogin}>Login</button>
//       {error && <p>{error}</p>}
//     </div>
//   );
// }

// export default Login;
